export default __webpack_public_path__ + "static/media/shoes4.a61e1f19.jpg";